import { Checkbox } from"antd";
import "./checkbox.css"

const CheckBoxUI  = (props:any) =>{ 
    const { children, style, onChange, className, variant, color } = props;

    return <Checkbox style={style ? style : null} className={className} onChange={onChange}>{children}</Checkbox>
}

export default CheckBoxUI;